document.addEventListener('DOMContentLoaded', function () {
    var swiper_el = document.querySelector('#heroSwiperCarousel');

    var swiper = new Swiper(".mySwiper", {
        effect: "coverflow",
        grabCursor: true,
        spaceBetweenSlides: 5,
        loop: true,
        centeredSlides: true,
        slidesPerView: 1.25,
        coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            modifier: 1,
            slideShadows: true,
        },  breakpoints: {
            // when window width is >= 480px
            480: {
            slidesPerView: 2,
            spaceBetween: 10
            },
            // when window width is >= 640px
            769: {
            slidesPerView: 3,
            spaceBetween: 20
            },
            1025: {
            slidesPerView: 4,
            spaceBetween: 15
            }
        }, navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        }, on: {
            afterInit: function() {
                swiper_el.classList.remove('is-loading');
                swiper_el.classList.add('is-ready');
            },
        },
    });

});